export default "__VITE_ASSET__D21BGfs7__"